import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import ResponsiveTitle from './ResponsiveTitle';

interface PageTitleProps {
  title: string;
  icon: ReactNode;
  action?: ReactNode;
}

/**
 * Composant réutilisable pour les titres de page avec icône
 */
const PageTitle: React.FC<PageTitleProps> = ({ title, icon, action }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: action ? 'space-between' : 'flex-start',
      alignItems: { xs: 'flex-start', md: 'center' },
      gap: { xs: 2, md: 0 },
      mb: 3,
      width: '100%',
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, md: 2 }, // Réduit le gap sur mobile pour donner plus d'espace au titre
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 4,
        px: { xs: 2, md: 3 }, // Padding horizontal standard (revert)
        py: 1,
        color: 'white',
        // FIX: Utilisation d'une marge à gauche pour décaler le titre après le bouton
        ml: { xs: 9, md: 0 },
        // Contrainte de largeur pour éviter le débordement horizontal
        width: { xs: 'calc(100% - 90px)', md: 'auto' },
        maxWidth: '100%',
        boxSizing: 'border-box', // Important : inclut le padding dans le calcul de width
        overflow: 'hidden'
      }}>
        {icon}
        <Box sx={{
          flex: 1,
          minWidth: 0, // Permet au flex item de rétrécir en dessous de sa taille de contenu
          overflow: 'hidden'
        }}>
          <ResponsiveTitle variant="h4" minFontSize={8} maxFontSize={34} style={{ fontWeight: 'bold' }}>
            {title}
          </ResponsiveTitle>
        </Box>
      </Box>
      {action && (
        <Box>
          {action}
        </Box>
      )}
    </Box>
  );
};

export default PageTitle;
